import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const MaintenanceSkeleton = memo(() => {
  return (
    <SettingCardSkeleton
      titleWidth={120}
      controls={["switch"]}
    />
  );
});

MaintenanceSkeleton.displayName = "MaintenanceSkeleton";

export default MaintenanceSkeleton;
